"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import Link from "next/link";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { cn } from "@/shared/lib/utils";
import type { ContactInfoItemContent } from "@/features/contact/types/contact-page-content";
const ICON_MAP = {
  email: Mail,
  phone: Phone,
  location: MapPin,
  hours: Clock
} as const;
interface ContactInfoProps {
  items: ContactInfoItemContent[];
}
export function ContactInfo(t0) {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col gap-4">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(item, i) {
  const Icon = ICON_MAP[item.icon];
  const inner = <div className="flex items-start gap-4"><div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary"><Icon className="h-5 w-5" strokeWidth={1.75} /></div><div className="flex flex-col gap-0.5"><span className="text-xs font-semibold tracking-wider text-muted-foreground uppercase">{item.label}</span><span className={cn("text-[15px] leading-snug font-medium text-foreground", item.href && "text-primary underline-offset-2 hover:underline")}>{item.value}</span></div></div>;
  return <motion.div key={item.id} initial={{
    opacity: 0,
    x: 16
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true,
    margin: "-40px"
  }} transition={{
    duration: 0.5,
    delay: i * 0.08
  }} className="rounded-2xl border border-border bg-card px-5 py-4 shadow-sm transition-shadow hover:shadow-md">{item.href ? <Link href={item.href}>{inner}</Link> : inner}</motion.div>;
}